import axios from "axios";
import axios2 from "@/axios";

import store from "@/store";
import router from "@/router";

const state = {
  customer: null,
  customerUpdatedTime: null,

  distributorsAvailable: [],
  selectedDistributor: 0,
};

const getters = {
  retrieveCustomer: (state) => {
    if (state.customer) {
      return state.customer;
    }else{
      return 'no_customers';
    }
  },

  retrieveSelectedDistributor: (state) => {
    return state.selectedDistributor;
  },

  isDistFilterEnabled: (state, getters, rootState, rootGetters) => {
    //  console.log("----GETTER FROM CONFIG STORE ----"+rootGetters.retrieveShowDistributorFilters)
    if (state.customer != null) {
      if (
        state.distributorsAvailable.length > 1 &&
        rootGetters.retrieveShowDistributorFilters
      ) {
        return true;
      }
      return false;
    }
    return false;
  },

  retrieveDistributorsAvailable: (state) => {
    return state.distributorsAvailable;
  },
  retrieveFormatedDists: (state) => {
    let distsData = [{ text: "All", value: 0 }];
    if (state.distributorsAvailable.length > 1) {
      state.distributorsAvailable.forEach((dist) => {
        distsData.push({ text: dist.name, value: parseInt(dist.number) });
      });
    }

    return distsData;
  },

  retrieveCustomerUpdatedTime: (state) => {
    return state.customerUpdatedTime;
  },

  retrieveAccountCustomerCredit: (state) => {
    //Credit set to 0 so it is not read as null
    let credit = 0;
    if (state.customer != null) {
      if (state.customer.credit) {
        credit = state.customer.credit;
      }
    }
    return credit;
  },

  retrieveCustomerAddress: (state) => {
    if (state.customer) {
      return {
        name: state.customer.customer.name,

        address_line_1: state.customer.customer.address_line_1,
        address_line_2: state.customer.customer.address_line_2,
        address_line_3: state.customer.customer.address_line_3,
        address_line_4: state.customer.customer.address_line_4,

        postcode: state.customer.customer.postcode,
        telephone_no: state.customer.customer.telephone_no,
      };
    } else {
      return false;
    }
  },

  retrieveIsCashCustomer: (state) => {
    let retrieveIsCashCustomer = false;

    if (state.customer != null) {
      if (parseInt(state.customer.customer.delivery_account_no) == 1) {
        retrieveIsCashCustomer = true;
      }
    }

    return retrieveIsCashCustomer;
  },

  retrieveIsCncCustomer: (state) => {
    let retrieveIsCncCustomer = false;

    if (state.customer != null) {
      if (parseInt(state.customer.customer.delivery_account_no) == 3) {
        retrieveIsCncCustomer = true;
      }
    }

    return retrieveIsCncCustomer;
  },

  retrieveIsPaymentWithOrderCustomer: (state) => {
    let isPaymentCustomer = false;

    if (state.customer != null) {
      if (parseInt(state.customer.customer.acc_type) == 5) {
        isPaymentCustomer = true;
      }
    }

    return isPaymentCustomer;
  },

  retrieveIsCncOnly: (state) => {
    let retrieveIsCncCustomer = false;

    if (state.customer != null) {
      return parseInt(state.customer.cncOnly);
    }

    return retrieveIsCncCustomer;
  },

  retrieveIsPaymentCustomer: (state) => {
    let retrieveIsCncCustomer = false;

    if (state.customer != null) {
      if (parseInt(state.customer.customer.acc_type) == 5) {
        retrieveIsCncCustomer = true;
      }
    }

    return retrieveIsCncCustomer;
  },

  retrieveAllAvailableDays: (state) => {
    let allAvailableDays = [];

    if (state.customer != null) {
      if (state.customer.allAvailableDays.length > 0) {
        allAvailableDays = state.customer.allAvailableDays;
      }
    }

    return allAvailableDays;
  },
  retrieveStandingOrderDays: (state) => {
    let availableDays = [];

    if (state.customer != null) {
      if (state.customer.SOallAvailableDays.length > 0) {
        availableDays = state.customer.SOallAvailableDays;
      }
    }

    return availableDays;
  },
  retrieveCustomerDeilveryDays: (state) => {
    if (state.customer) {
      let deliveryDays = {
        deliveryDayMonday: state.customer.customer.delivery_day_monday,
        deliveryDayTuesday: state.customer.customer.delivery_day_tuesday,
        deliveryDayWednesday: state.customer.customer.delivery_day_wednesday,
        deliveryDayThursday: state.customer.customer.delivery_day_thursday,
        deliveryDayFriday: state.customer.customer.delivery_day_friday,
        deliveryDaySaturday: state.customer.customer.delivery_day_saturday,
        deliveryDaySunday: state.customer.customer.delivery_day_sunday,
      };
      return deliveryDays;
    }
  },

  retrieveCustomerAvailableDays: (state) => {
    if (state.customer) {
      return state.customer.allowedDays;
    }
  },
};

const actions = {
  async getCustomer({ commit }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      customerNo: this.getters.retrieveSelectedCustomer
    };
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios.post("get-customer", params);

    if (response.data.success == true) {
      console.log(response.data);
      commit("setCustomer", response.data);
    } else {
      console.log("-- Get Customer False");

      /*

      store.dispatch("userSignoutAction");

      router.push({ name: "Welcome" }).catch((er) => {
        console.log(er);
      });

      */

      if (response.data) {
        if (response.data.message) {
          console.log("-- Setting Snackbar");

          store.dispatch("snackbarStatic/setSnackbar", {
            text: response.data.message,
            color: "error",
          });
        }
      } else {
        store.dispatch("setSnackbar", {
          text: "Error retrieving your customer information",
          color: "error",
        });
      }
    }

    console.log("-- Get Customer Store");
    console.log(response.data);
    return response.data;
  },

  async getDistributors({ commit }) {
    console.log("-- Finding Distributors");
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      customerNo : this.getters.retrieveSelectedCustomer
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2
      .post("general/get-distributors", params)
      .catch((e) => {
        console.log("-- Get Dist failure");
        console.log(e);
        return false;
      });

    if (response.data.success == true) {
      commit("setDistributors", Object.values(response.data.distributors));
    } else {
      console.log("-- Get Distributors False");

      // if (response.data) {
      //   if (response.data.message) {
      //     console.log("-- Setting Snackbar");

      //     store.dispatch("snackbarStatic/setSnackbar", {
      //       text: response.data.message,
      //       color: "error",
      //     });
      //   }
      // } else {
      //   store.dispatch("setSnackbar", {
      //     text: "Error retrieving your customer information",
      //     color: "error",
      //   });
      // }
    }

    return response.data;
  },

  clearCustomer({ commit }) {
    commit("setCustomer", null);
    commit("setSelectedDistributor", 0);
    commit("setDistributors", []);
  },
};

const mutations = {
  //Assign the object we got from the API to be our customer
  setCustomer: (state, customer) => {
    state.customer = customer;
    state.customerUpdatedTime = new Date().getTime();
  },

  setDistributors: (state, dist) => {
    state.distributorsAvailable = dist;
  },

  setSelectedDistributor: (state, dist) => {
    state.selectedDistributor = dist;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
